import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useLocale } from '@/modules/locale/model/locale';
import { collectionService } from '@/services/collection';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useCollectionTranslation() {
    const router = useAppRouter();
    const route = useRoute();
    const crudAction = useCrudActions();

    const { localeSupportedOptions, getListSupported } = useLocale();

    const model = reactive({
        collectionId: StringUtils.toNumber(route.params.collectionId),
        locale: null as string | null,
        title: '',
        hasData: false
    });

    const validations = {
        title: { required },
        locale: { required }
    };

    const v$ = useVuelidate(validations, model);

    const beforeFetch = async () => {
        await getListSupported();
        if (!localeSupportedOptions.value.length) {
            router.go(-1);
            return;
        }
    };

    const fetch = crudAction.executeAction({
        canExecute: () => model.locale != null,
        request: () => collectionService.getText(model.collectionId, model.locale),
        onSuccess: ({ data }) => {
            model.hasData = true;
            model.title = data.title;
        },
        onError: () => {
            model.hasData = false;
            model.title = '';
        }
    });

    const actions = {
        updateText: crudAction.excuteAndNotify({
            validator: v$,
            request: () => collectionService.updateText(model.collectionId, model.locale, model.title),
            onSuccess: fetch
        }),
        removeText: crudAction.confirmAndRemove({
            request: () => collectionService.removeText(model.collectionId, model.locale),
            onSuccess: fetch
        })
    };

    onMounted(async () => {
        await beforeFetch();
        await fetch();
    });

    return { model, v$, fetch, beforeFetch, actions, localeSupportedOptions };
}
